import PropTypes from "prop-types"
import React from "react"
import ventraip_logo from '../images/ventraip-logo.png';
import netorigin_logo from '../images/netorigin-logo.svg';


const Header = () => (
  <header className={'acquisition__header header'}>
      <div className={`container clearfix header__container`}>
          <a className={`header__login`} target={`_blank`} href={'https://clients.netorigin.com.au/clientarea.php'}>
              Login to Netorigin
          </a>
          <div className={'header__wrapper'}>
              <a className={`header__logo header__logo--ventraip logo clearfix`} href={`https://ventraip.com.au`} target={"_blank"}>
                  <img src={ventraip_logo} alt={'VentraIP Australia'} className={`logo__image`}/>
              </a>
              <div className={`header__separator`} />
              <a className={`header__logo header__logo--netorigin logo clearfix`} href={`https://www.netorigin.com.au/`} target={"_blank"}>
                  <img src={netorigin_logo} alt={'Netorigin'} className={`logo__image`}/>
              </a>
          </div>
      </div>
  </header>
)

export default Header
